import { v4 as uuid } from 'uuid';

import { ForecasterGuidanceConfigBlockState } from './types';

const defaultState: ForecasterGuidanceConfigBlockState = {
    settings: {
        fontSize: 100,
    },
    databilities: [
        {
            id: uuid(),
            datasetId: '',
            capabilityId: 'product',
        },
    ],
};

export default defaultState;
